import { graphql } from '@teachino/shared-infrastructure';

export const moveTopicsToFolderMutation = graphql(`
  mutation moveTopicsToFolder($topicIds: [String!]!, $folderId: String) {
    moveTopics(
      moveTopicInput: { topicIds: $topicIds, libraryFolderId: $folderId }
    ) {
      __typename
    }
  }
`);
